'use client';

// Full-page screen shown in place of any customer data page when the
// signed-in owner's Powston subscription has ended (status cancelled /
// transferred). Rendered by SubscriptionGate. It keeps the NavBar so the
// two escape hatches the user needs stay reachable:
//   - the "Send feedback" button (lives in the NavBar) to request help, and
//   - the profile / subscription link to resubscribe.
// Tone follows the CLAUDE.md guidance: calm and factual, state what Powston
// can no longer do and the single next step, not blame.

import Link from 'next/link';
import { CreditCard, LifeBuoy } from 'lucide-react';
import NavBar from '@/app/components/navbar';
import Footer from '@/app/components/Footer';

const SubscriptionCancelled: React.FC = () => {
  return (
    <main className="flex min-h-screen flex-col items-center justify-between p-4 bg-background text-foreground">
      <NavBar />
      <section className="flex flex-1 flex-col items-center justify-center w-full">
        <div className="max-w-xl w-full p-8 bg-card border border-border rounded-lg shadow-sm text-center">
          <div className="flex justify-center mb-4">
            <CreditCard className="w-10 h-10 text-amber-600 dark:text-amber-400" />
          </div>
          <h1 className="text-2xl font-bold mb-3">
            Your Powston subscription has ended
          </h1>
          <p className="text-muted-foreground mb-6 leading-relaxed">
            Without an active subscription, Powston is no longer controlling or
            verifying your system, so your trading data and site pages aren’t
            available. Reactivate your subscription to turn Powston back on and
            restore access.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              href="/profile#subscription"
              className="inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-md bg-emerald-600 text-white hover:bg-emerald-700 transition-colors"
            >
              <CreditCard className="w-4 h-4" />
              Subscribe from your profile
            </Link>
          </div>
          <p className="text-sm text-muted-foreground mt-6 inline-flex items-center gap-1.5 justify-center flex-wrap">
            <LifeBuoy className="w-4 h-4 flex-shrink-0" />
            <span>
              Need a hand? Use the <span className="font-semibold">Send feedback</span> button
              in the top menu to reach us.
            </span>
          </p>
        </div>
      </section>
      <Footer />
    </main>
  );
};

export default SubscriptionCancelled;
